import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "lux_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setShow(true); } catch (_) {}
  }, []);

  const save = (choice) => {
    try { localStorage.setItem(KEY, JSON.stringify({ choice, at: Date.now() })); } catch (_) {}
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-[440px] z-[130] glass rounded-2xl p-5 md:p-6 shadow-lg"
          role="dialog" aria-live="polite" data-testid="cookie-banner"
        >
          <p className="font-display text-lg text-[#2A1F14] mb-1">Rispettiamo la tua privacy</p>
          <p className="text-[#2A1F14]/70 text-sm leading-relaxed mb-4">
            Usiamo cookie tecnici indispensabili e, con il tuo consenso, cookie di analisi per migliorare il sito.
            Puoi cambiare idea in qualsiasi momento. Consulta la <Link to="/legal/cookie" className="text-gold link-underline">Cookie Policy</Link>.
          </p>
          <div className="flex gap-3">
            <button onClick={() => save("all")} data-testid="cookie-accept-all" className="flex-1 py-2.5 rounded-full bg-gold text-black text-sm font-medium hover:bg-[#D4A056] transition-colors">Accetta tutto</button>
            <button onClick={() => save("necessary")} data-testid="cookie-accept-necessary" className="flex-1 py-2.5 rounded-full border border-[#2A1F14]/25 text-[#2A1F14] text-sm hover:border-gold hover:text-gold transition-colors">Solo tecnici</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
